import { render } from "./PageTitleIcon.vue?vue&type=template&id=22028fbc"
import script from "./PageTitleIcon.vue?vue&type=script&lang=js"
export * from "./PageTitleIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/PageTitleIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "22028fbc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('22028fbc', __exports__)) {
    api.reload('22028fbc', __exports__)
  }
  
  module.hot.accept("./PageTitleIcon.vue?vue&type=template&id=22028fbc", () => {
    api.rerender('22028fbc', render)
  })

}


export default __exports__